const kSpinnerStyle = {
  loadingSpinner: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

export default kSpinnerStyle;
